import React, { useState } from "react";
import "./../../components/style/Connexion.css";
import Connexion from "./Connexion";
import DialogBox from "../util/DialogBox";
import { LoadingBox, closeLoadingBox } from "../util/LoadingBox";
import { useTranslation } from "react-i18next";
import { authApi } from "../../api/auth";
import { getNewPasswordError } from "../../api/passwordPolicy";

function Inscription() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [showConnexion, setShowConnexion] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { t } = useTranslation();
  const LOGO_CONNEXION_IMG = "/rm_imgs/logo_connexion.png";

  /**
   * Inscription via la session serveur (POST /auth/register).
   * La réponse est générique (anti-énumération) : on affiche toujours le
   * même message de prise en compte, sans préciser si l'e-mail existe.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailPattern.test(email)) {
      console.log("Adresse e-mail invalide");
      DialogBox({
        text: t("invalidEmail"),
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    if (password !== passwordConfirmation) {
      console.log("jest: Mots de passe différents");
      DialogBox({
        text: t("samePwdTwice"),
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    if (!password) {
      console.log("jest: Mot de passe requis");
      DialogBox({
        text: t("passwordRequired"),
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    // Même règle que utils/validation.js côté backend (ADR 0004).
    const passwordError = getNewPasswordError(password);
    if (passwordError) {
      DialogBox({
        text: t(passwordError),
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    if (!name) {
      console.log("jest: Nom requis");
      DialogBox({
        text: t("nameRequired"),
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    LoadingBox({ text: t("loadingInscription"), icon: "info" });

    const { status } = await authApi.register({ name, email, password });
    closeLoadingBox();

    if (status === 200 || status === 201) {
      // Réponse volontairement générique : l'e-mail existe peut-être déjà.
      DialogBox({
        text: t("successInscription"),
        icon: "success",
        confirmButtonText: "OK",
      });
      setShowConnexion(true);
    } else {
      const errorMessage = status === 400
        ? "registrationInvalidData"
        : status === 429
          ? "registrationTooManyAttempts"
          : "registrationUnavailable";
      DialogBox({
        text: t(errorMessage),
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  if (showConnexion) {
    return <Connexion />;
  } else {
    return (
      <div className="App">
        <div className="AppContainer container d-flex  flex-column align-items-center justify-content-center ">
          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
            className="accessPageInscription d-flex flex-column align-items-center justify-content-center"
          >
            <img
              src={LOGO_CONNEXION_IMG}
              alt="Logo RoadMaker"
              className="logoInscription"
            />
            <div className="inputContainer">
              <h6 htmlFor="identifiant" className="labelConnexion">
                {t("name")}
              </h6>
              <input
                id="identifiant"
                type="text"
                className="inputInscription"
                value={name}
                required
                onChange={(e) => {
                  setName(e.target.value);
                }}
                aria-label="Identifiant"
              />
              <h6 htmlFor="email" className=" labelConnexion mt-3">
                {t("email")}
              </h6>
              <input
                id="email"
                type="email"
                className="inputInscription"
                value={email}
                required
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                aria-label="Email"
              />
              <h6 htmlFor="password" className="labelConnexion mt-3">
                {t("password")}
              </h6>
              <div className="passwordContainer d-flex align-items-center justify-content-center ">
                <input
                  type={showPassword ? "text" : "password"}
                  className="inputPasswordInscription "
                  value={password}
                  required
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  aria-label="Mot-de-passe"
                  aria-describedby="registration-password-requirements"
                />
                <button
                  className="buttonShowPassword"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="bi bi-eye-slash"></i>
                  ) : (
                    <i className="bi bi-eye"></i>
                  )}
                </button>
              </div>
              <small
                id="registration-password-requirements"
                className="registrationPasswordHelp"
              >
                {t("registrationPasswordRequirements")}
              </small>
              <h6 htmlFor="confirm-password" className="labelConnexion mt-3">
                {t("confirmPassword")}
              </h6>

              <div className="passwordContainer d-flex align-items-center justify-content-center mb-5">
                <input
                  id="confirm-password"
                  type={showConfirmPassword ? "text" : "password"}
                  className="inputPasswordInscription"
                  value={passwordConfirmation}
                  required
                  onChange={(e) => {
                    setPasswordConfirmation(e.target.value);
                  }}
                  aria-label="confirm-password"
                />
                <button
                  className="buttonShowPassword"
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <i className="bi bi-eye-slash"></i>
                  ) : (
                    <i className="bi bi-eye"></i>
                  )}
                </button>
              </div>
            </div>
            <div className=" buttonsContainerInscription d-flex flex-column  justify-content-center align-items-center">
              <button
                type="submit"
                className="btnMdpOublie px-5"
                aria-label="inscription-form"
              >
                {t("signUp")}
              </button>
              <button
                type="button"
                className="btnBack mt-3 mb-3 px-5 py-2"
                onClick={() => {
                  setShowConnexion(true);
                }}
              >
                {t("backConnexionPage")}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Inscription;
